module.exports = __webpack_public_path__ + "static/piggy-e72fd8d8efca462d1dd0e755060f8e3f.svg";